import {attributesToProps, HTMLReactParserOptions} from 'html-react-parser';
import dayjs from 'dayjs';
import {dateFormat, shortDateFormat} from '../../../constants/constants';
import surveyRoutes from '../../surveys/routes';
import {Link} from '@mui/material';

const NODE_TYPES = {
  tag: 'tag'
};

const TAGS = {
  span: 'span'
};

const DATA_TYPE = 'data-type';

const CONTENT_TYPE = {
  dateWithTime: 'date-with-time',
  date: 'date',
  patientSurveyLink: 'patient-survey',
  createPatientSurveyLink: 'create-patient-survey'
};

export const getNotificationOptions = (
    history, handleCloseNotifications
): HTMLReactParserOptions => {
  return {
    replace: ({attribs = {}, type, name, children = []}: any) => {
      if (!name || !attribs || type !== NODE_TYPES.tag) {
        return;
      }

      const props = attributesToProps(attribs);
      const content = children?.[0]?.data;

      if (name === TAGS.span && attribs.hasOwnProperty(DATA_TYPE)) {
        if (attribs[DATA_TYPE] === CONTENT_TYPE.patientSurveyLink) {
          const id = attribs['data-patient-survey-id'];

          const handleClick = () => {
            history.push(surveyRoutes.item(id));
            handleCloseNotifications();
          };

          return <Link onClick={handleClick} className="link">{content}</Link>;
        }

        if (attribs[DATA_TYPE] === CONTENT_TYPE.createPatientSurveyLink) {
          const patientId = attribs['data-patient-id'];
          const callSheetId = attribs['data-call-sheet-id'];

          const handleClick = () => {
            history.push(
                surveyRoutes.create(), {
                  initialPatientId: patientId,
                  initialCallSheetId: callSheetId
                });
            handleCloseNotifications();
          };

          return <Link onClick={handleClick} className="link">{content}</Link>;
        }

        if (attribs[DATA_TYPE] === CONTENT_TYPE.dateWithTime) {
          return <span {...props}>{dayjs(content).format(dateFormat)}</span>;
        }

        if (attribs[DATA_TYPE] === CONTENT_TYPE.date) {
          return (
            <span {...props}>{dayjs(content).format(shortDateFormat)}</span>
          );
        }
      }
    }
  };
};
